// extracted by mini-css-extract-plugin
export default {"grid":"games-module--grid--Ovfh-"};